import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningRoute extends Route {
  @service router;
  @service organisation;
  beforeModel(transition) {
    // if (this.organisation.is_trial) {
    //   this.router.transitionTo('backlog.initiatives.index');
    // }
    if (
      transition.to?.name.split('.').length >= 3 //i.e. it is an inner page of planning dashboard
    );
    else this.router.transitionTo('planning.dashboard');
  }
}

export default instrumentRoutePerformance(PlanningRoute);
